// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Deadline_wrapper__YfGWy","wrapperBlack":"Deadline_wrapperBlack__ScWI6","wrapperRed":"Deadline_wrapperRed__b53Kr","wrapperClosed":"Deadline_wrapperClosed__D_9kU"};